import { render, staticRenderFns } from "./retail-marketing.vue?vue&type=template&id=3cdeded3&scoped=true&"
import script from "./retail-marketing.vue?vue&type=script&lang=js&"
export * from "./retail-marketing.vue?vue&type=script&lang=js&"
import style0 from "./retail-marketing.vue?vue&type=style&index=0&id=3cdeded3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdeded3",
  null
  
)

export default component.exports